window.jQuery = $;
window.$ = $;
require("./css/reset.scss");
require("./css/layout.scss");
require("./css/header.scss");
require("./css/site-logo.scss");
require("./css/buttons.scss");
require("./css/sprites.scss");